import axios from "axios";
import {store} from "../App";
import {getHubBaseUrl, getHubUrl} from "../utils/configUtils";
import {logoutAgency} from "./authenticationActions";
import { navigate } from "../utils/navigationUtils";
import { t } from "@lingui/core/macro";


export function getResourceImageUrl(resourceId, {width = 0, category = ""} = {}) {
    const baseUrl = getHubBaseUrl();
    let imageUrl = `${baseUrl}blobs/image?reference=${resourceId}`;

    if (width) {
        imageUrl += `&width=${width}`;
    }

    if (category) {
        imageUrl += `&category=${category}`;
    }

    return imageUrl;
}

export function getImageUrlById(imageId, {width = 0, category = ""} = {}) {
    const baseUrl = getHubBaseUrl();
    let imageUrl = `${baseUrl}blobs/image?id=${imageId}`;

    if (width) {
        imageUrl += `&width=${width}`;
    }

    if (category) {
        imageUrl += `&category=${category}`;
    }

    return imageUrl;
}

export function getFromHub(options, successCallback, errorCallback) {
    return hubNetworkRequest('GET', options, null, successCallback, errorCallback);
}

export function postToHub(options, payload, successCallback, errorCallback) {
    return hubNetworkRequest('POST', options, payload, successCallback, errorCallback);
}

export function putToHubNew(options, payload, successCallback, errorCallback) {
    return hubNetworkRequest('PUT', options, payload, successCallback, errorCallback);
}

export function deleteFromHubNew(options, successCallback, errorCallback) {
    return hubNetworkRequest('DELETE', options, null, successCallback, errorCallback);
}

// For simulating a slow network request
// async function stall(stallTime = 3000) {
//     await new Promise(resolve => setTimeout(resolve, stallTime));
// }

async function hubNetworkRequest(method, options, payload, successCallback = (data) => {}, errorCallback = (e) => {}) {
    let path = "";
    let headers = {};
    let logoutOn403 = true;

    if(typeof options === "object") {
        ({path, headers = {}, logoutOn403 = true} = options);
    }

    if(typeof options === "string") {
        path = options;
    }

    try {
        const HUB_URL = getHubUrl();

        //simulate network delay - TODO remove
        // await stall(Math.ceil(Math.random() * 2000));

        const response = await axios({
            method,
            url: HUB_URL + path,

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SessionId': store.getState().authentication.sessionId,
                ...headers,
            },
            data: payload,
        });
        successCallback(response.data);
        return response.data;
    }
    catch (e) {
        errorCallback({
            response: e.response,
            message: e.message
        });

        if (e.response){
            if(e.response.status === 409 && e.response.data === "Itinerary closed for ancillary booking") {
                navigate("/");
            }

            if (e.response.status === 403 && logoutOn403) {
                const tradePortalLogoutUrl = store.getState().authentication?.tradeportal?.logoutUrl;

                // PassengerLogout reads the logout url before clearing it, and its route is not behind AuthRoute
                if (tradePortalLogoutUrl) {
                    navigate(t({id: "/logoutUser"}));
                    return {error: e};
                }

                logoutAgency(); //this will log out agency as well as passenger
                navigate("/login");
            }
        }

        return {error: e};
    }
}
